"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValidatorTeamName = exports.getValidatorSignup = exports.getValidatorPlayerName = exports.getValidatorPassword = exports.getValidatorChatMessage = exports.getDiscordId = void 0;
const Yup = __importStar(require("yup"));
const getValidatorSignup = () => {
    return Yup.object().shape({
        username: Yup.string()
            .min(2, "Username must be at least 2 characters")
            .max(20, "Username must be less than 20 characters")
            .required("Username is required"),
        password: Yup.string()
            .min(6, "Password must be at least 6 characters")
            .max(50, "Password must be less than 50 characters")
            .required("Password is required"),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref("password"), undefined], "Passwords do not match")
            .required("Password confirm is required"),
        email: Yup.string().email("Invalid email").required("Email is required"),
    });
};
exports.getValidatorSignup = getValidatorSignup;
const getValidatorPassword = () => {
    return Yup.object().shape({
        password: Yup.string()
            .min(6, "Password must be at least 6 characters")
            .max(50, "Password must be less than 50 characters")
            .required("Password is required"),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref("password"), undefined], "Passwords do not match")
            .required("Password confirm is required"),
    });
};
exports.getValidatorPassword = getValidatorPassword;
const getValidatorTeamName = () => {
    return Yup.object().shape({
        name: Yup.string()
            .min(2, "Team name must be at least 2 characters")
            .max(20, "Team name must be less than 20 characters")
            .required("Team name is required"),
    });
};
exports.getValidatorTeamName = getValidatorTeamName;
const getValidatorPlayerName = () => {
    return Yup.object().shape({
        name: Yup.string()
            .min(2, "Player name must be at least 2 characters")
            .max(20, "Player name must be less than 20 characters")
            .required("Player name is required"),
    });
};
exports.getValidatorPlayerName = getValidatorPlayerName;
const getValidatorChatMessage = () => {
    return Yup.object().shape({
        name: Yup.string().max(200, "Chat message must be less than 200 characters"),
    });
};
exports.getValidatorChatMessage = getValidatorChatMessage;
const getDiscordId = () => {
    return Yup.object().shape({
        name: Yup.string().max(100, "Discord ID  must be less than 100 characters"),
    });
};
exports.getDiscordId = getDiscordId;
